export default __webpack_public_path__ + "static/media/8.d7a84401.jpeg";